var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVipLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 8.85C15.9 8.45 15.25 8.4 14.85 8.75C12.9 10.4 11.1 10.4 9.14998 8.75C8.74998 8.4 8.09998 8.45 7.74998 8.85C7.39998 9.25 7.44998 9.9 7.84998 10.25C10.55 12.55 13.4 12.55 16.1 10.25C16.55 9.9 16.6 9.25 16.25 8.85ZM18.3 2C19 2 19.6 2.35 20 2.9L20.05 3L23.25 8.7C23.65 9.4 23.55 10.3 23.05 10.95L23 11.05L13.5 21.35C13.45 21.4 13.45 21.45 13.4 21.45C12.6 22.15 11.4 22.15 10.65 21.4L10.55 21.3L1.04998 11C0.499978 10.4 0.349978 9.5 0.749978 8.75L0.799978 8.65L3.94998 3C4.29998 2.4 4.89998 2 5.54998 2H18.3Z",
    fill: "url(#paint0_linear_690_4091)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_690_4091",
    x1: 23.2994,
    y1: 12.9205,
    x2: -5.70127,
    y2: 12.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEF67"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipLogo);
export default __webpack_public_path__ + "static/media/vipLogo.27c86cd895f259ef4f495b0c691693d2.svg";
export { ForwardRef as ReactComponent };